import { Component, Prop, Vue } from "vue-property-decorator";
import WithRender from "./Notifications330KpiCards.html";
import { Inject } from "vue-di-container";
import Notifications330Service from "../Notifications330Service";
import { Notifications330FilterModel } from "../Notifications330FilterModel";
import { buildNotifications330ScopePayload } from "../notifications330DetailsShared";

@WithRender
@Component({
    diProvide: [Notifications330Service],
})
export default class Notifications330KpiCards extends Vue {
    @Inject(Notifications330Service)
    public notifications330Service!: Notifications330Service;

    @Prop({ required: true }) public filter!: Notifications330FilterModel;

    public isLoading: boolean = false;
    private requestVersion: number = 0;

    public kpis: any = this.createEmptyKpis();

    public async refresh(): Promise<void> {
        if (!this.filter) {
            this.kpis = this.createEmptyKpis();
            return;
        }

        this.isLoading = true;
        const currentRequestVersion = ++this.requestVersion;

        const payload = buildNotifications330ScopePayload(this.filter);

        const res = await this.notifications330Service.GetKpis(payload);
        if (currentRequestVersion !== this.requestVersion) {
            return;
        }

        if (res) {
            this.kpis = {
                allComplaints: this.toNumber(res.allComplaints),
                pendingComplaints: this.toNumber(res.pendingComplaints),
                resolvedComplaints: this.toNumber(res.resolvedComplaints),
                avgProcessingBusinessDays: this.toNumber(res.avgProcessingBusinessDays),
            };
        } else {
            this.kpis = this.createEmptyKpis();
        }

        this.isLoading = false;
    }

    private createEmptyKpis(): any {
        return {
            allComplaints: 0,
            pendingComplaints: 0,
            resolvedComplaints: 0,
            avgProcessingBusinessDays: 0,
        };
    }

    private toNumber(v: any): number {
        if (v === null || v === undefined || v === "") return 0;

        const n = Number(v);
        return isNaN(n) ? 0 : n;
    }

    public displayCount(v: any): string {
        return String(this.toNumber(v));
    }

    public formatDays(v: any): string {
        return (
            this.toNumber(v).toFixed(1) +
            " " +
            String(this.$t("monitorDashboard.daysSuffix"))
        );
    }
}
